import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "country-switcher__country-name" }
const _hoisted_2 = {
  key: 0,
  class: "country-switcher__currency"
}

import { computed } from 'vue';
import useCountrySwitch from '@/composables/useCountrySwitch';
import useContext from '@/composables/useContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySwitcher',
  setup(__props) {

const { mitt } = useContext();
const { activeCountryOption, availableCountries } = useCountrySwitch();

const label = computed(() => {
  if (!activeCountryOption.value?.englishUsName) return '';
  return activeCountryOption.value.englishUsName.trim();
});

const currencyId = computed(() => {
  return activeCountryOption.value?.currencyId
    ? `(${activeCountryOption.value.currencyId})`
    : '';
});

const canChangeCountry = computed(() => ((availableCountries?.value || []).length > 1));

return (_ctx: any,_cache: any) => {
  return (_unref(activeCountryOption))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(mitt).emit('open-country-select'))),
        class: _normalizeClass(["country-switcher clean-button", { 'country-switcher__switchable': _unref(canChangeCountry) }])
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(label)), 1),
        (_unref(currencyId))
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(currencyId)), 1))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})